import React from 'react';

import { Title, Button, ButtonsGroup } from 'components/commons';
import trafficIcon from 'assets/svg/traffic-signal.svg';

type AnalysisTimeoutLayoutProps = {
    onOk(): void;
}

const AnalysisTimeoutLayout: React.FC<AnalysisTimeoutLayoutProps> = ({ onOk }) => (
    <div className="message-box-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box">
                    <img className="icon" src={trafficIcon} />

                    <Title>ainda estamos <br />trabalhando!</Title>

                    <p className="text">A nossa análise vai demorar um <br className="d-block d-sm-none" />pouquinho mais.</p>

                    <p className="text">Mas fica tranquilo, assim que <br className="d-block d-sm-none" />tivermos uma resposta, você vai <br className="d-block d-sm-none" />receber por e-mail!</p>
                </div>

                <ButtonsGroup align="left">
                    <Button label="continuar" onClick={onOk} />
                </ButtonsGroup>
            </div>
        </div>
    </div>
);

export default AnalysisTimeoutLayout;
